import { Injectable } from '@angular/core';
import { MListData } from '../../master/m_list_data';
import { CommonLibService } from '@lib/services';
import { Subject } from 'rxjs';
import { CheckinCommonStoreService } from '../checkin-common-store/checkin-common-store.service';
import { AgreementLangItem } from '../../interface';

@Injectable({
  providedIn: 'root',
})
export class AgreementService {
  /** 同意事項チェックボックスの選択状態を通知するSubject */
  agreementCheckboxSubject = new Subject<boolean>();

  /** 次画面へ遷移するボタンの押下を通知するSubject */
  clickNextButtonSubject = new Subject<boolean>();

  /** キャンセルボタンを押下を通知するSubject */
  clickCancelButtonSubject = new Subject<boolean>();

  /** 規約画面で言語を切り替える必要がない言語 */
  private readonly isNotNeedChangeLangs: string[] = ['ja', 'en'];

  constructor(private common: CommonLibService, private checkinCommon: CheckinCommonStoreService) {}

  /**
   * 言語を切り替える必要があるかの言語切り替え有無を判定し返却する
   * @returns 言語が日本語もしくは英語の場合false、それ以外の言語の場合true
   */
  isNeedChangeLang() {
    const lang = this.common.aswContextStoreService.aswContextData.lang;
    return !this.isNotNeedChangeLangs.includes(lang);
  }

  /**
   * 汎用マスタ(リスト)から言語選択に必要な言語情報を抽出して返却する
   */
  extractSelectedLangs(mListDataArray: MListData[]): AgreementLangItem[] {
    const lang = this.common.aswContextStoreService.aswContextData.lang;
    const mListDataPd065 = mListDataArray
      .filter((list: MListData) => (lang === undefined || list.lang === lang) && list.data_code === 'PD_065')
      .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

    return this.isNotNeedChangeLangs.map((lang) => {
      return {
        value: lang,
        display_content: mListDataPd065?.find((item) => item.value === lang)?.display_content ?? '',
      };
    });
  }

  /**
   * チェックイン共通に変更前オフィスと変更前言語情報を追加する
   */
  setPreviousOfficeAndPreviousLangToCheckinCommon() {
    const updateData = {
      previousPointOfSaleId: this.common.aswContextStoreService.aswContextData.pointOfSaleId,
      previousLang: this.common.aswContextStoreService.aswContextData.lang,
    };
    this.checkinCommon.updateCheckinCommon(updateData);
  }

  /**
   * チェックイン共通の変更前オフィスと変更前言語情報を削除する
   */
  resetPreviousOfficeAndPreviousLangToCheckinCommon() {
    this.checkinCommon.updateCheckinCommon({
      previousPointOfSaleId: undefined,
      previousLang: undefined,
    });
  }
}
